import Vue from 'vue';
import Router from 'vue-router';

import home from './views/home.vue';
import services from './views/services.vue';
import equipment from './views/equipment.vue';
import history from './views/history.vue';
import contact from './views/contact.vue';

Vue.use(Router);

const router = new Router({
    base: "/",
    routes: [
        {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/services',
            name: 'services',
            component: services
        },
        {
            path: '/equipment',
            name: 'equipment',
            component: equipment
        },
        {
            path: '/history',
            name: 'history',
            component: history
        },
        {
            path: '/contact',
            name: 'contact',
            component: contact
        },
        // -------------------------
        { path: '*', redirect: '/home' }, // catch all use case
    ]
});

export default router;